import React from 'react';
import { Badge, Flex } from "@chakra-ui/react"
import { IEmailAIExtractedOwner } from "../../../types/common";

const OwnerBadges = ({ owners }: { owners: IEmailAIExtractedOwner[]}) => {
    return (
        <Flex wrap="wrap" gap={2} maxW="100%">
            {owners?.map((owner, i) => {
                if (owner.fullName.trim()) {
                    return (
                      <Badge
                        key={i}
                        variant="surface"
                        maxW="100%"
                        whiteSpace="normal"
                        wordBreak="break-word"
                        overflowWrap="anywhere"
                      >
                        {owner.fullName}
                      </Badge>
                    )
                } else return null
            })}
        </Flex>
    )    
}

export default OwnerBadges;